import WelcomePage from '@/pages/WelcomePage.vue';
import LoginPage from '@/pages/LoginPage.vue';
import SignUpPage from '@/pages/SignUpPage.vue';
import OnBoardingPage from '@/pages/OnBoardingPage.vue';
import { RouteRecordRaw } from 'vue-router';
import AnnouncementPage from '@/pages/AnnouncementPage.vue';
import PersonalizePage from '@/pages/PersonalizePage.vue';
import QuestionPage from '@/pages/QuestionPage.vue';
import VerifyAccountPage from '@/pages/VerifyAccountPage.vue';
import ProfilePage from '@/pages/ProfilePage.vue';
import MyProfilePage from '@/pages/MyProfilePage.vue';
import MyAccountPage from '@/pages/MyAccountPage.vue';
import MyDocumentPage from '@/pages/MyDocumentPage.vue';
import NotificationsPage from '@/pages/NotificationsPage.vue';
import TabsPage from '@/pages/TabsPage.vue';
import MyDocumentDetailPage from '@/pages/MyDocumentDetailPage.vue';
import RecoveryPasswordPage from '@/pages/RecoveryPasswordPage.vue';
import RecoveryWithTokenPage from '@/pages/RecoveryWithTokenPage.vue';
import MySettingsPage from '@/pages/MySettingsPage.vue';
import BillingPage from '@/pages/BillingPage.vue';
import InvoiceDetailPage from '@/pages/InvoiceDetailPage.vue';
import BookingPage from '@/pages/BookingPage.vue';
import AnnouncementPropertyPage from '@/pages/AnnouncementPropertyPage.vue';
import CheckInPage from '@/pages/CheckInPage.vue';
import CheckOutPage from '@/pages/CheckOutPage.vue';
import WelcomeUniversityPage from '@/pages/WelcomeUniversityPage.vue';
import ChatPage from '@/pages/ChatPage.vue';
import AbroadVerifyAccountPage from '@/pages/AbroadVerifyAccountPage.vue';
import OnBoardingAbroadPage from '@/pages/OnBoardingAbroadPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'welcome',
    component: WelcomePage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/university/:universitySlug',
    name: 'welcome.university',
    component: WelcomeUniversityPage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/recovery-password',
    name: 'recoveryPassword',
    component: RecoveryPasswordPage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/reset-password',
    name: 'recovery',
    component: RecoveryWithTokenPage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/sign-up',
    name: 'signUp',
    component: SignUpPage,
    meta: {
      requiredUnauth: true,
    },
  },
  {
    path: '/verify-account',
    name: 'verifyAccount',
    component: VerifyAccountPage,
  },
  {
    path: '/register',
    name: 'AbroadVerifyAccount',
    component: AbroadVerifyAccountPage,
  },
  {
    path: '/on-boarding',
    name: 'onBoarding',
    component: OnBoardingPage,
  },
  {
    path: '/on-boarding-abroad',
    name: 'onBoardingAbroad',
    component: OnBoardingAbroadPage,
  },
  {
    path: '/personalize/questions',
    name: 'personalizeQuestions',
    component: QuestionPage,
  },
  {
    path: '/personalize',
    name: 'personalize',
    component: PersonalizePage,
  },
  {
    path: '/:rentalId/preview',
    name: 'AnnouncementPage',
    component: AnnouncementPage,
  },
  {
    path: '/property/:propertyId/preview',
    name: 'AnnouncementPropertyPage',
    component: AnnouncementPropertyPage,
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/my',
    name: 'profile.my',
    component: MyProfilePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/settings',
    name: 'profile.settings',
    component: MySettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/account',
    name: 'profile.account',
    component: MyAccountPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/documents',
    name: 'profile.documents',
    component: MyDocumentPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/documents/detail',
    name: 'profile.documents.detail',
    component: MyDocumentDetailPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing',
    name: 'Billing',
    component: BillingPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/invoice/:invoiceId',
    name: 'InvoiceDetail',
    component: InvoiceDetailPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/booking/:bookingId',
    name: 'Bookings',
    component: BookingPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/check-in/:bookingId',
    name: 'CheckIn',
    component: CheckInPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/check-out',
    name: 'CheckOut',
    component: CheckOutPage,
  },
  {
    path: '/check-out/reservation/:bookingId/rental/:rentalId',
    name: 'CheckOutReservation',
    component: CheckOutPage,
  },
  {
    path: '/reservation/:bookingId/documents',
    name: 'reservationDocuments',
    component: MyDocumentPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/chat/:bookingId',
    name: 'Chat',
    component: ChatPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/home/',
    component: TabsPage,
    name: 'Home',
    children: [
      {
        path: '',
        redirect: '/home/guides',
        name: 'Redirect',
      },
      {
        path: 'guides',
        name: 'Guides',
        component: () => import('@/pages/HomePage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'explore',
        name: 'Explore',
        component: () => import('@/pages/ExplorePage.vue'),
      },
      {
        path: 'my-stay',
        name: 'MyStay',
        component: () => import('@/pages/HomeMyPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('@/pages/SupportPage.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'perks',
        name: 'Perks',
        component: () => import('@/pages/PerksPage.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/perks/:id',
    name: 'EventDetail',
    component: () => import('@/pages/EventDetailPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/pages/MaintenancePage.vue'),
  },
];

export default routes;
